import React, { useEffect } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { FaTimes } from 'react-icons/fa';
import styles from '../../pages/Account.module.css';

const ScannerModal = ({ onClose, onScanSuccess }) => {
    useEffect(() => {
        const scanner = new Html5QrcodeScanner(
            "reader",
            {
                fps: 10,
                qrbox: { width: 250, height: 250 },
                aspectRatio: 1.0
            },
            /* verbose= */ false
        );

        scanner.render(onScanSuccess, (err) => {
            // Un-comment to see errors in console
            // console.warn(err);
        });

        return () => {
            scanner.clear().catch(error => {
                console.error("Failed to clear html5QrcodeScanner. ", error);
            });
        };
    }, [onScanSuccess]);

    return (
        <div className={styles.modalOverlay} style={{ zIndex: 2000 }}>
            <div className={styles.modalCard} style={{ maxWidth: '500px', width: '90%' }}>
                <div className={styles.modalHeader}>
                    <h3>Scanner un Article</h3>
                    <button className={styles.closeBtn} onClick={onClose}><FaTimes /></button>
                </div>
                <div style={{ padding: '20px' }}>
                    <p style={{ fontSize: '0.9rem', color: '#64748b', marginBottom: '15px' }}>
                        Placez le QR Code de l'article devant la caméra pour le détecter automatiquement.
                    </p>
                    <div id="reader" style={{ width: '100%', borderRadius: '12px', overflow: 'hidden' }}></div>
                </div>
            </div>
        </div>
    );
};

export default ScannerModal;
